module.exports = __webpack_public_path__ + "static/media/panton-bold-italic.3faa8c7f.otf";